module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/landing-pages-city-14f593face43941510fb78a6dfc02e1e.svg";